import PropTypes from 'prop-types';
import {ANNUAL_PLAN_STATUS_LABELS} from '../../config';

export const annualPlan = PropTypes.shape({
  id: PropTypes.number,
  year: PropTypes.number,
  status: PropTypes.oneOf(Object.values(ANNUAL_PLAN_STATUS_LABELS)),
  get_status_display: PropTypes.oneOf(['Borrador', 'Completado', 'En ejecución']),
  interventions: PropTypes.arrayOf(PropTypes.number)
});